<div class="idn-grid-filter">
<mat-form-field class="user-category-field">
    <mat-label>ALM Studio Certified</mat-label>
    <mat-select (selectionChange)="onSelectionChange($event)" [(ngModel)]="selectedValue" #selectData>
      <mat-option *ngFor="let data of idnCertifiedData" [value]="data.value">
        {{data.name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>